<template>
  <div id="app">
    <router-view/>
    <BackTop :height="100" :bottom="80">
      <div class="top">
        <i class="el-icon-arrow-up"/>
      </div>
    </BackTop>
  </div>
</template>
<script>

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'app',
  components: {},
  data() {
    return {}
  },
  created() {
    const baseSize = 20 // 1rem = 20px(设计稿);
    const baseWidth = 1920 // 1920
    // 屏幕宽度 / 设计稿宽度 * 基本宽度
    console.log("000000000000", document.documentElement.clientWidth)
    const fontSize = (document.documentElement.clientWidth / baseWidth * baseSize).toFixed(2)
    document.getElementsByTagName('html')[0].style.fontSize = fontSize + 'px'
  }
}
</script>
<style lang="less" scoped>
.top {
  //padding: 0.5rem;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(0, 0, 0, .5);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
